import { render, staticRenderFns } from "./ConstructorsTableBody.vue?vue&type=template&id=97bae30c&scoped=true&"
import script from "./ConstructorsTableBody.vue?vue&type=script&lang=js&"
export * from "./ConstructorsTableBody.vue?vue&type=script&lang=js&"
import style0 from "./ConstructorsTableBody.vue?vue&type=style&index=0&id=97bae30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bae30c",
  null
  
)

export default component.exports